<template>
  <div class="app-content-wrapper">
    <div class="search-wrapper">
      <search-component ref="search" :search-condition="searchCondition" :search-buttons="searchButtonList"
        :fuzzySearchPlaceholder="fuzzySearchPlaceholder" :validFunction="validSearchParams" :showMerchantSearch="true"
        router-name="/wallet/settlement/details">

      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table :table-set="tableCondition" :service-function="getSettlementDetailList"
        :first-parameters="isBatchSearch ? {} : getInitParams()" :is-first-automatic-visit="false"
        :showMerchantNo="true" ref="table" router-name="/wallet/settlement/details">
        <template #markupAmount="{ row }">
          <div class="pointer" @click="showFeeDetail('MARKUP', row.id)">
            {{ formatAmountWithCurrency(row.markupAmount) }}
          </div>
        </template>
        <template #handlingAmount="{ row }">
          <div class="pointer" @click="showFeeDetail('HANDLING', row.id)">
            {{ row.handlingAmount }}
          </div>
        </template>
        <template #feeAmount="{ row }">
          <div class="pointer" @click="showFeeDetail('FEE', row.id)">
            {{ row.feeAmount }}
          </div>
        </template>
      </custom-table>
    </div>
    <custom-message ref="customMessage"></custom-message>
    <fee-detail ref="feeDetail"></fee-detail>
  </div>
</template>
<script>

import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import { ShowSuccessMessage, ShowErrorMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData, splicingAmountAndCurrency } from '@/utils/tools/constant';
import { formatAmountWithCurrency } from '@/utils/tools/format';
import { getTodayParams, initToday } from '@/utils/tools/time';
import SettlementDetailsService from '@/views/settlement/api/settlement-details';
import { QueryHistoryOptions } from '@/views/transaction/status/transaction';

import FeeDetail from './components/fee-detail/index.vue';

export default {
  components: {
    SearchComponent,
    CustomTable,
    CustomMessage,
    FeeDetail,
  },
  data() {
    return {
      getTodayParams,
      ...SettlementDetailsService,
      isBatchSearch: false,
      txnTypeList: [],
      txnStatusList: [],
      cardTypeList: [],
      feeStatusList: [],
      settleStatusList: [],
      websiteTypeList: [],
      shareStatusList: [],
      downloading: false,
      // eslint-disable-next-line max-len
      fuzzySearchPlaceholder: `${this.$t('message.tableCommon.txnSerialNumber')};${this.$t('message.tableCommon.merchantOrderNumber')};${this.$t('message.settlement.batchNo')};${this.$t('message.tableCommon.originalTxnSerialNumber')}`,
      searchCondition: [
        {
          key: ['startTime', 'endTime'],
          name: 'message.settlement.time',
          defValue: initToday(),
          type: 'date_time',
        },
        {
          key: 'isHistory',
          name: 'message.tableCommon.queryHistory',
          type: 'select',
          defValue: '',
          options: QueryHistoryOptions,
          isInternationalization: true,
        },
        {
          key: ['txnStartTimes', 'txnEndTimes'],
          name: 'message.settlement.txnTime',
          // defValue: initToday(),
          type: 'date_time',
        },
        {
          key: 'productType',
          name: 'message.tableCommon.productType',
          type: 'select',
          defValue: '',
        },
        {
          key: 'txnType',
          name: 'message.tableCommon.txnType',
          type: 'select',
          defValue: '',
          options: this.txnTypeList,
        },
        {
          key: 'txnStatus',
          name: 'message.tableCommon.txnStatus',
          type: 'select',
          defValue: '',
        },
        {
          key: 'shareStatus',
          name: 'message.transaction.dividendStatus',
          type: 'select',
          defValue: '',
          options: [],
        },
        // {
        //   key: 'cardType',
        //   name: 'message.tableCommon.cardType',
        //   type: 'select',
        //   defValue: '',
        // },
        // {
        //   key: 'feeStatus',
        //   name: 'message.settlement.feeStatus',
        //   type: 'select',
        //   defValue: '',
        // },
        // {
        //   key: 'settleStatus',
        //   name: 'message.settlement.settlementStatus',
        //   type: 'select',
        //   defValue: '',
        // },
      ],
      searchButtonList: [
        {
          type: 'download',
          permissionCode: 'wallet:settlement:detail:download',
          func: async (param) => {
            if (!this.downloading) {
              this.downloading = true;
              try {
                await this.downloadSettlementDetail(param);
                ShowSuccessMessage(this.$t('message.common.downloadTask'));
              } catch (err) {
                //
              }
              this.downloading = false;
            }
          },
        },
      ],
      tableCondition: [
        { // 结算日期
          titleBar: { type: 'text', title: 'message.settlement.time' },
          key: 'settleDate',
          type: 'text',
        },
        // TODO:新增交易完成时间
        {
          titleBar: { type: 'text', title: 'message.settlement.txnCompleteTime' },
          key: 'txnCompleteTime',
          type: 'text',
        },
        { // 交易时间
          titleBar: { type: 'text', title: 'message.settlement.txnTime' },
          key: 'txnTime',
          type: 'text',
        },
        { // 结算批次号
          titleBar: { type: 'text', title: 'message.settlement.batchNo' },
          key: 'settleBatchNo',
          type: 'text',
        },
        { // 交易流水号
          titleBar: { type: 'text', title: 'message.tableCommon.txnSerialNumber' },
          key: 'serviceId',
          type: 'text',
        },
        { // 源交易流水号
          titleBar: { type: 'text', title: 'message.tableCommon.originalTxnSerialNumber' },
          key: 'originalTxnId',
          type: 'text',
          itemMinWidth: 250,
        },
        // APPID
        {
          titleBar: { type: 'text', title: 'message.settlement.appId' },
          key: 'appId',
          type: 'text',
          itemMinWidth: 170,
        },
        // 网址
        {
          titleBar: { type: 'text', title: 'message.settlement.transactionUrl' },
          key: 'txnWebsite',
          type: 'text',
          itemMinWidth: 170,
        },
        { // 商户订单号
          titleBar: { type: 'text', title: 'message.tableCommon.merchantOrderNumber' },
          key: 'externalOrderId',
          type: 'text',
        },
        { // 商户原始订单号
          titleBar: { type: 'text', title: 'message.tableCommon.merchantOriginalOrderNumber' },
          key: 'masterOrderId',
          type: 'text',
          itemMinWidth: 200,
        },
        { // 支付类型
          titleBar: { type: 'text', title: 'message.tableCommon.productType' },
          key: 'productTypeName',
          type: 'text',
        },
        { // 卡类型
          titleBar: { type: 'text', title: 'message.tableCommon.cardCategoryName' },
          key: 'cardProductName',
          type: 'text',
        },
        { // 卡表示
          titleBar: { type: 'text', title: 'message.tableCommon.cardIdentifier' },
          key: 'cardCategoryName',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.cardBinCountry' },
          key: 'cardBinCountry',
          type: 'text',
        },
        { // 卡种
          titleBar: { type: 'text', title: 'message.tableCommon.cardType' },
          key: 'cardType',
          type: 'text',
        },
        { // 子卡种
          titleBar: { type: 'text', title: 'message.tableCommon.subCardType' },
          key: 'walletTypeCode',
          type: 'text',
        },
        { // 下单金额
          titleBar: { type: 'text', title: 'message.tableCommon.orderAmount' },
          key: 'orderAmount',
          type: 'text',
        },
        { // 交易类型
          titleBar: { type: 'text', title: 'message.tableCommon.txnType' },
          key: 'txnType',
          type: 'text',
          textFunc: (data) => getEnantiomericValue(this.txnTypeList, data.txnType),
        },
        { // 交易状态
          titleBar: { type: 'text', title: 'message.tableCommon.txnStatus' },
          key: 'txnStatus',
          type: 'text',
          textFunc: (data) => getEnantiomericValue(this.txnStatusList, data.txnStatus),
        },
        { // 交易金额
          titleBar: { type: 'text', title: 'message.tableCommon.txnAmount' },
          key: 'txnAmount',
          type: 'text',
          // textFunc: (data) => splicingAmountAndCurrency(data.txnAmount && data.txnAmount.currency, data.txnAmount && data.txnAmount.amount),
        },
        { // 平台类型
          titleBar: { type: 'text', title: 'message.tableCommon.platformType' },
          key: 'websiteType',
          type: 'text',
          textFunc: (data) => {
            if (`${data.websiteType}` === '0') {
              return this.$t('message.common.unlimited');
            }
            return getEnantiomericValue(this.websiteTypeList, data.websiteType);
          },
        },
        { // 处理费
          titleBar: { type: 'text', title: 'message.settlement.handlingAmount' },
          key: 'handlingAmount',
          type: 'slot',
        },
        { // 手续费
          titleBar: { type: 'text', title: 'message.settlement.serviceAmount' },
          key: 'feeAmount',
          type: 'slot',
        },
        { // 保证金
          titleBar: { type: 'text', title: 'message.settlement.deposit' },
          key: 'depositAmount',
          type: 'text',
        },
        { // Scheme Fee
          titleBar: { type: 'text', title: 'message.tableCommon.schemeAmt' },
          key: 'schemeAmount',
          type: 'text',
          textFunc: (data) => splicingAmountAndCurrency(data.schemeAmount && data.schemeAmount.currency, data.schemeAmount && data.schemeAmount.amount),
        },
        { // Interchange Fee
          titleBar: { type: 'text', title: 'message.tableCommon.interchangeAmt' },
          key: 'interchangeAmount',
          type: 'text',
          textFunc: (data) => splicingAmountAndCurrency(data.interchangeAmount && data.interchangeAmount.currency, data.interchangeAmount && data.interchangeAmount.amount),
        },
        { // Markup
          titleBar: { type: 'text', title: 'message.tableCommon.markupAmt' },
          key: 'markupAmount',
          type: 'slot',
          textFunc: (data) => splicingAmountAndCurrency(data.markupAmount && data.markupAmount.currency, data.markupAmount && data.markupAmount.amount),
        },
        // { // 税费
        //   titleBar: { type: 'text', title: 'message.tableCommon.taxes' },
        //   key: 'taxes',
        //   type: 'text',
        //   textFunc: (data) => splicingAmountAndCurrency(data.taxes && data.taxes.currency, data.taxes && data.taxes.amount),
        // },
        { // 平台费
          titleBar: { type: 'text', title: 'message.tableCommon.platformFee' },
          key: 'platformFeeAmount',
          type: 'text',
        },
        { // 欺诈管理费
          titleBar: { type: 'text', title: 'message.tableCommon.fraudAdministrationFee' },
          key: 'fraudAdministrationFee',
          type: 'text',
          textFunc: (data) =>
            splicingAmountAndCurrency(data.fraudAdministrationFeeAmount && data.fraudAdministrationFeeAmount.currency, data.fraudAdministrationFeeAmount && data.fraudAdministrationFeeAmount.amount),
        },
        { // 风控管理费
          titleBar: { type: 'text', title: 'message.settlement.decisionManagementFee' },
          key: 'decisionManagementFeeAmount',
          type: 'text',
          textFunc: (data) =>
            splicingAmountAndCurrency(data.decisionManagementFeeAmount && data.decisionManagementFeeAmount.currency, data.decisionManagementFeeAmount && data.decisionManagementFeeAmount.amount),

        },
        { // 结算金额
          titleBar: { type: 'text', title: 'message.settlement.settlementAmount' },
          key: 'sumAmount',
          type: 'text',
        },
        { // 结算币种
          titleBar: { type: 'text', title: 'message.settlement.currency' },
          key: 'settleCurrency',
          type: 'text',
        },
        { // 分账状态
          titleBar: { type: 'text', title: 'message.transaction.dividendStatus' },
          key: 'shareStatus',
          type: 'text',
          textFunc: (data) => getEnantiomericValue(this.shareStatusList, data.shareStatus),
        },
        // { // 计费状态
        //   titleBar: { type: 'text', title: 'message.settlement.feeStatus' },
        //   key: 'feeStatusName',
        //   type: 'text',
        //   textFunc: (data) => getEnantiomericValue(this.feeStatusList, data.feeStatus),
        // },
        // { // 结算状态
        //   titleBar: { type: 'text', title: 'message.settlement.settlementStatus' },
        //   key: 'settleStatusName',
        //   type: 'text',
        //   textFunc: (data) => getEnantiomericValue(this.settleStatusList, data.settleStatus),
        // },
      ],
      isQueryHistory: this.$route.query.isHistory === '1',
    };
  },
  methods: {
    formatAmountWithCurrency,
    getInitParams() {
      return {
        ...getTodayParams('startTime', 'endTime'),
        // ...getTodayParams('txnStartTimes', 'txnEndTimes'),
      };
    },
    validSearchParams(params) {
      if (params.keywords) {
        return true;
      }
      if (!params.startTime && !params.endTime && !params.txnStartTimes && !params.txnEndTimes) {
        ShowErrorMessage(this.$t('message.settlement.searchTimeTip'));
        return false;
      }
      if (params.startTime || params.endTime) {
        if (!params.startTime) {
          ShowErrorMessage(this.$t('message.searchCommon.startTimeTip', { time: this.$t('message.settlement.time') }));
          return false;
        }
        if (!params.endTime) {
          ShowErrorMessage(this.$t('message.searchCommon.endTimeTip', { time: this.$t('message.settlement.time') }));
          return false;
        }
      }

      if (params.txnStartTimes || params.txnEndTimes) {
        if (!params.txnStartTimes) {
          ShowErrorMessage(this.$t('message.searchCommon.startTimeTip', { time: this.$t('message.settlement.txnTime') }));
          return false;
        }
        if (!params.txnEndTimes) {
          ShowErrorMessage(this.$t('message.searchCommon.endTimeTip', { time: this.$t('message.settlement.txnTime') }));
          return false;
        }
      }
      try {
        this.isQueryHistory = params.isHistory === '1';
        if (this.$refs.search) {
          this.$refs.search.initSearchButtons();
        }
      } catch (err) {
        //
      }

      return true;
    },

    async initMethod() {
      await GlobalData.getDictList(['CREDIT_CARD_TYPE', 'FEE_STATUS', 'MERC_SETTLE_STATUS', 'PRODUCT_TYPE', 'TXN_TYPE', 'TXN_STATUS', 'WEB_TYPE', 'SHARE']).then((res) => {
        this.$refs.search.setSearchSelectOptions('productType',
          initSelectedData(res.PRODUCT_TYPE));
        this.txnTypeList = initSelectedData(res.TXN_TYPE);
        this.txnStatusList = initSelectedData(res.TXN_STATUS);
        this.cardTypeList = initSelectedData(res.CREDIT_CARD_TYPE);
        this.feeStatusList = initSelectedData(res.FEE_STATUS);
        this.settleStatusList = initSelectedData(res.MERC_SETTLE_STATUS);
        this.websiteTypeList = initSelectedData(res.WEB_TYPE);
        this.shareStatusList = initSelectedData(res.SHARE);
        // this.$refs.search.setSearchSelectOptions('cardType', this.cardTypeList);
        this.$refs.search.setSearchSelectOptions('txnType', this.txnTypeList);
        this.$refs.search.setSearchSelectOptions('txnStatus', this.txnStatusList);
        this.$refs.search.setSearchSelectOptions('shareStatus', this.shareStatusList);
        // this.$refs.search.setSearchSelectOptions('settleStatus', this.settleStatusList);
        // this.$refs.search.setSearchSelectOptions('feeStatus', this.feeStatusList);
      }).catch(() => {
      });

      this.$refs.table.firstVisitHttp();
    },
    async showFeeDetail(type, id) {
      try {
        this.$store.state.loadingInstance = this.$loading();

        const res = await this.getFeeDetail({
          feeCalType: type,
          settlementId: id,
          isHistory: this.isQueryHistory,
        });

        if (res) {
          this.$refs.feeDetail.open({
            type,
            data: res,
          });
        }
      } finally {
        this.$store.state.loadingInstance.close();
      }
    },
  },
  mounted() {
    this.initMethod();
    // this.$refs.search.setInputValue('keywords', this.$route.query.keywords);
    if (this.$route.query.keywords) {
      this.$refs.search.setInputValue('startTime', '');
      this.$refs.search.setInputValue('endTime', '');
      this.$refs.search.setInputValue('txnStartTimes', '');
      this.$refs.search.setInputValue('txnEndTimes', '');
    }
  },
  created() {
    if (this.$route.query.keywords) {
      this.isBatchSearch = true;
    }
  },
};
</script>
<style lang="scss">
#refundDetail .is-bordered-label {
  width: 50%;
}

.pointer {
  color: #2d8cf0;
  cursor: pointer;

  &:hover {
    color: #57a3f3;
  }
}
</style>
